<template>
    <!-- 单选题 -->
    <div>
        <div class="page-line">
            <div class="text">分页</div>
        </div>
        <!-- 底部操作栏 -->
        <div class="footer-operation" v-if="footerShow">
            <action-bar
                class="action-bar"
                @addCopy="() => emits('copyQuestion', dataList)"
                @deleteQuestion="() => emits('deleteQuestion')"
                @view="(e) => emits('singlePreview', e)"
            ></action-bar>
        </div>
    </div>
</template>
<script setup name="kr-paging">
// js
import { provide, watch } from "vue";
// components
import ActionBar from "@/components/action/ActionBar.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
// 复制题目，删除题目, 数据改变, 单题预览;
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview"]);
watch(
    () => props.dataList,
    (curr, old) => {
        emits("change", curr);
    },
    { deep: true }
);
provide("data", props.dataList);
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

.page-line {
    width: 100%;
    height: 1px;
    border-top: 1px dashed rgba(183, 186, 191, 1);
    margin-top: 42px;
    margin-bottom: 20px;
    position: relative;
    .text {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        padding: 5px 20px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(112, 120, 134, 1);
        background-color: #fff;
    }
}
</style>
